"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = undefined;

var _revalidate = require("revalidate");

var validate = exports.validate = (0, _revalidate.combineValidators)({
  captcha: (0, _revalidate.isRequired)({
    message: 'Please complete the captcha by selecting "I\'m not a robot" above'
  })
});


//////////////////
// WEBPACK FOOTER
// ./src/utils/upgradeToAnnualFormValidation.js
// module id = 2826
// module chunks = 0